import styled from 'styled-components';

import { colors, mixins } from '@nhl/common-styled-component';

export const TrophyTombstone = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    align-items: flex-start;
    background-color: ${colors.$0};
    color: ${colors.F};
    overflow: hidden;
    padding: 20px 0;

    ${mixins.tabletLandscapeUp} {
        min-height: 730px;
    }

    ${mixins.desktopUp} {
        padding: 40px 20px 0 20px;
    }

    a {
        color: ${colors.D};
    }
`;

export const TrophyLeft = styled.div`
    flex: 0 0 100%;
    height: 100%;
    padding: 0 10px;
    z-index: 1;
    background-image: linear-gradient(left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 65%, rgba(0, 0, 0, 0) 100%);

    ${mixins.tabletPortraitUp} {
        padding: 0 20px;
    }

    ${mixins.desktopUp} {
        align-self: center;
        padding: 0 20px 40px;
        flex: 0 0 calc(50% - 20px);
    }
`;

const trophySizing = `
    ${mixins.tabletPortraitUp} {
        max-width: 75%;
    }

    ${mixins.desktopUp} {
        max-width: 100%;
    }
`;

export const TrophyDescription = styled.div`
    padding: 10px 0;
    font-size: 1.14em;
    line-height: 1.8em;
    ${trophySizing}
`;

export const TrophyName = styled.h2`
    font-size: 24px;
    ${trophySizing}
`;

export const TrophyRight = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;

    ${mixins.phoneOnly} {
        display: none;
    }

    ${mixins.desktopUp} {
        position: relative;
        top: inherit;
        left: inherit;
        display: flex;
        padding: 0 20px;
        width: auto;
        height: auto;
        flex: 0 0 calc(50% - 20px);
    }
`;

export const TrophyImageContainer = styled.div`
    height: 100%;

    ${mixins.desktopUp} {
        align-self: flex-start;
    }
`;

export const TrophyImage = styled.img`
    position: absolute;
    left: -200px;
    bottom: 0;
    height: 90%;
    width: auto;

    ${mixins.tabletPortraitUp} {
        left: inherit;
        right: -30%;
    }

    ${mixins.tabletLandscapeUp} {
        right: -10%;
    }

    ${mixins.desktopUp} {
        position: relative;
        max-width: 100%;
        height: auto;
    }
`;
